"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FromNumber = exports.Into = exports.getSymbol = exports.getLabel = exports.SYMBOL_MAP = exports.Measure = exports.Unit = exports.UsUnit = exports.ImperialUnit = exports.SiUnit = exports.System = exports.NAMESPACE = exports.Volume = exports.Time = exports.Temperature = exports.Pressure = exports.Mass = exports.FlowRate = exports.Energy = exports.Count = exports.Compound = exports.Common = void 0;
const effect_1 = require("effect");
const tags_1 = require("../utils/tags");
const Compound = __importStar(require("./compound"));
const Count = __importStar(require("./count"));
const Energy = __importStar(require("./energy"));
const FlowRate = __importStar(require("./flow-rate"));
const Mass = __importStar(require("./mass"));
const Pressure = __importStar(require("./pressure"));
const Temperature = __importStar(require("./temperature"));
const Time = __importStar(require("./time"));
const Volume = __importStar(require("./volume"));
exports.Common = __importStar(require("./common"));
exports.Compound = __importStar(require("./compound"));
exports.Count = __importStar(require("./count"));
exports.Energy = __importStar(require("./energy"));
exports.FlowRate = __importStar(require("./flow-rate"));
exports.Mass = __importStar(require("./mass"));
exports.Pressure = __importStar(require("./pressure"));
exports.Temperature = __importStar(require("./temperature"));
exports.Time = __importStar(require("./time"));
exports.Volume = __importStar(require("./volume"));
exports.NAMESPACE = 'Unit';
var common_1 = require("./common");
Object.defineProperty(exports, "System", { enumerable: true, get: function () { return common_1.System; } });
exports.SiUnit = effect_1.Schema.Union(...FlowRate.SiFlowRate.members, ...Mass.SiMass.members, ...Pressure.SiPressure.members, ...Temperature.SiTemperature.members, ...Volume.SiVolume.members).annotations({
    identifier: `${exports.NAMESPACE}.SiUnit`,
});
exports.ImperialUnit = effect_1.Schema.Union(...Mass.ImperialMass.members, Pressure.ImperialPressure, ...Temperature.ImperialTemperature.members, ...Volume.ImperialVolume.members).annotations({
    identifier: `${exports.NAMESPACE}.ImperialUnit`,
});
exports.UsUnit = effect_1.Schema.Union(...FlowRate.UsFlowRate.members, ...Mass.UsMass.members, Pressure.UsPressure, Temperature.UsTemperature, ...Volume.UsVolume.members).annotations({
    identifier: `${exports.NAMESPACE}.UsUnit`,
});
exports.Unit = effect_1.Schema.Union(...Compound.Compound.members, ...Count.Count.members, ...Energy.Energy.members, ...FlowRate.FlowRate.members, ...Mass.Mass.members, ...Pressure.Pressure.members, ...Temperature.Temperature.members, ...Time.Time.members, ...Volume.Volume.members).annotations({
    identifier: `${exports.NAMESPACE}.Unit`,
});
exports.Measure = effect_1.Schema.Union(Compound.Compound, Count.Count, Energy.Energy, FlowRate.FlowRate, Mass.Mass, Pressure.Pressure, Temperature.Temperature, Time.Time, Volume.Volume).annotations({
    identifier: `${exports.NAMESPACE}.Measure`,
});
exports.SYMBOL_MAP = {
    ...Compound.SYMBOL_MAP,
    ...Count.SYMBOL_MAP,
    ...Energy.SYMBOL_MAP,
    ...FlowRate.SYMBOL_MAP,
    ...Mass.SYMBOL_MAP,
    ...Pressure.SYMBOL_MAP,
    ...Temperature.SYMBOL_MAP,
    ...Time.SYMBOL_MAP,
    ...Volume.SYMBOL_MAP,
};
exports.getLabel = effect_1.Match.type().pipe(effect_1.Match.when(effect_1.Schema.is(Compound.Compound), ({ _tag }) => Compound.getLabel(_tag)), effect_1.Match.when(effect_1.Schema.is(Count.Count), Count.getLabel), effect_1.Match.when(effect_1.Schema.is(Energy.Energy), Energy.getLabel), effect_1.Match.when(effect_1.Schema.is(FlowRate.FlowRate), FlowRate.getLabel), effect_1.Match.when(effect_1.Schema.is(Mass.Mass), Mass.getLabel), effect_1.Match.when(effect_1.Schema.is(Pressure.Pressure), ({ _tag }) => Pressure.getLabel(_tag)), effect_1.Match.when(effect_1.Schema.is(Temperature.Temperature), ({ _tag }) => Temperature.getLabel(_tag)), effect_1.Match.when(effect_1.Schema.is(Time.Time), Time.getLabel), effect_1.Match.when(effect_1.Schema.is(Volume.Volume), Volume.getLabel), effect_1.Match.exhaustive);
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Utility function to create a schema that transforms a `Number` schema into the provided `unitSchema`.
 * Especially useful for when devices send bare numbers over the wire, where there is a known implicit unit of measure.
 */
const Into = (unitSchema) => (numberSchema) => {
    /**
     * A type assertion is needed here.
     * Otherwise, the decoded side of the returned schema is too wide,
     * since it has a `_tag` property not narrowed to the `_tag` of {@link T}.
     */
    const outTag = (0, tags_1.getTagLiteral)(unitSchema.fields._tag);
    return effect_1.Schema.transform(numberSchema, effect_1.Schema.Struct({
        _tag: effect_1.Schema.tag(outTag),
        amount: numberSchema.pipe(effect_1.Schema.filter(effect_1.Schema.is(unitSchema.fields.amount))),
    }), {
        strict: true,
        decode: (_, amount) => ({
            _tag: outTag,
            amount,
        }),
        encode: (_, { amount }) => amount,
    });
};
exports.Into = Into;
/**
 * Shorthand version of {@link Into}
 *
 * Note: The `amount` property on the decoded side may be wider than the number on the encoded side.
 * If you would like to avoid widening, use {@link Into} instead.
 */
const FromNumber = (unitSchema) => (0, exports.Into)(unitSchema)(effect_1.Schema.Number);
exports.FromNumber = FromNumber;
//# sourceMappingURL=index.js.map